// Owner ruling 2026-10-09: an invite never changes someone who is already a
// registered member of the organization. The server skips them -- no roles,
// groups or courses, no email, no invite -- and says so: POST /user-invite
// answers {status: "skipped", code: "invite.already_member", userID,
// message}; each /user-invite/ws row carries skipped, email, userID and
// message. Their access is changed on their member page.

export const ALREADY_MEMBER_MESSAGE = 'already a member: change their access on their page'

export const memberPagePath = userID => `/org/user/list/edit/${userID}`

// inviteOutcome: {email, userID, message} for a skipped member, else null.
// email names the single invite's address (a bulk row carries its own).
export const inviteOutcome = (result, email) => {
  if (!result || !(result.status === 'skipped' || result.skipped === true)) {
    return null
  }
  return { email: result.email || email, userID: result.userID, message: result.message || ALREADY_MEMBER_MESSAGE }
}
